import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AppBar, styled, Toolbar } from '@mui/material';
import { PersonAddAlt1 } from '@mui/icons-material';
import { Colors } from 'library';
import { RPillButton, RRow } from 'recruit/components';
import { CandidateAuthDialog } from 'recruit/shared/components/CandidateAuthDialog';
import { useRecruitCandidateUser } from 'recruit/context/RecruitCandidateUserContext';
import NavyLogo from 'assets/images/NavyLogo.svg';
import { CareersBaseUrl } from 'environmentVariables';

const AUTH_PATH_PREFIX = '/recruit-candidate/';
const AUTH_PATH_SEGMENTS = ['login', 'create-account', 'verify', 'set-password'];

export function RPublicHeader() {
    const { candidateUser } = useRecruitCandidateUser();
    const location = useLocation();
    const [authOpen, setAuthOpen] = useState(false);

    const onAuthPage = AUTH_PATH_SEGMENTS.some((segment) =>
        location.pathname.startsWith(`${AUTH_PATH_PREFIX}${segment}`),
    );
    const showCreateAccount = !candidateUser && !onAuthPage;
    const careersHomeUrl = CareersBaseUrl || '/careers';

    return (
        <>
            <StyledAppBar position="static">
                <StyledToolbar>
                    <LogoLink href={careersHomeUrl}>
                        <NavyLogo height={50} width={150} alt="tandem logo" />
                    </LogoLink>
                    <RRow gap="sm" align="center">
                        <RPillButton variant="secondary" href={careersHomeUrl}>
                            Browse jobs
                        </RPillButton>
                        {showCreateAccount && (
                            <RPillButton
                                onClick={() => setAuthOpen(true)}
                                icon={<PersonAddAlt1 sx={{ fontSize: 18 }} />}
                            >
                                Create an account
                            </RPillButton>
                        )}
                    </RRow>
                </StyledToolbar>
            </StyledAppBar>
            {authOpen && <CandidateAuthDialog initialMode="create-account" onClose={() => setAuthOpen(false)} />}
        </>
    );
}

const StyledAppBar = styled(AppBar)({
    backgroundColor: Colors.white,
    boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)',
});

const StyledToolbar = styled(Toolbar)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

const LogoLink = styled('a')({
    display: 'inline-flex',
    textDecoration: 'none',
});
